<div class="sandbox-container">
  <h3>Formula Sandbox</h3>
  <div class="subtitle">Try a formula against ad hoc input values. Nothing here is saved.</div>

  <div class="field">
    <label>Formula Type</label>
    <select [(ngModel)]="formulaType">
      <option value="BOOLEAN">Trigger Formula</option>
      <option value="NUMERIC">Plan Amount</option>
      <option value="STRING">Why Description</option>
    </select>
  </div>

  <div class="field">
    <label>Formula</label>
    <textarea rows="4" [(ngModel)]="formula" placeholder="e.g. n(agi) > 200000 &amp;&amp; b(has_business)"></textarea>
  </div>

  <div class="field">
    <label class="field-label-row">
      <span>Input Values (JSON)</span>
      <button type="button" class="detect-btn" (click)="detectVariables()">Detect Variables</button>
    </label>
    <textarea rows="5" [(ngModel)]="inputValuesText" (blur)="validateJson()" placeholder='{"agi": 250000, "has_business": true}'></textarea>
    <div class="field-error" *ngIf="jsonError">{{jsonError}}</div>
  </div>

  <button type="button" class="btn-primary" [disabled]="evaluating" (click)="evaluate()">Evaluate</button>

  <div class="result-panel" *ngIf="result">
    <div class="result-header" [ngClass]="{'result-ok': !result.errorMessage, 'result-error': result.errorMessage}">
      {{result.errorMessage ? 'Error' : 'Result'}}
    </div>
    <pre *ngIf="!result.errorMessage">{{result.actualResult}}</pre>
    <pre class="error-text" *ngIf="result.errorMessage">{{result.errorMessage}}</pre>
  </div>
</div>
